import {
    Stack,
    Button,
    Dialog, DialogContent, CircularProgress, Typography // Import Skeleton
} from '@mui/material';
import { Archive } from 'iconsax-react';
export default function ConfirmArchiveModal({ handleConfirmClose, isArchiveOpen, handleArchiveClose, loading, type }) {
    return (
        <>
            {/* Delete Confirmation Dialog */}
            <Dialog
                open={isArchiveOpen}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleArchiveClose(false);
                    }
                }}
                keepMounted
                //TransitionComponent={PopupTransition}
                aria-labelledby="column-delete-title"
                aria-describedby="column-delete-description"
                maxWidth="sm" // Set the maximum width
            >
                <DialogContent sx={{ mt: 2, my: 1, m: '20px' }} >
                    <Stack spacing={2}>
                        <Typography variant="h4" align="center">
                            Confirm {type === "Active" ? "Archive" : "Unarchive"}
                        </Typography>
                    </Stack>
                    <Stack alignItems="center" spacing={3.5}>
                        {/* <img src={Archive} alt="" /> */}

                        <Stack direction="row" spacing={2} sx={{ width: 1 }} className="trash-btn">
                            {
                                loading ?
                                    <CircularProgress size={"24px"} /> :
                                    <>
                                        <Button fullWidth onClick={() => handleArchiveClose(false)} color="secondary" variant="outlined">
                                            Cancel
                                        </Button>
                                        <Button fullWidth color="error" variant="contained" autoFocus onClick={handleConfirmClose}>
                                            Confirm
                                        </Button>
                                    </>
                            }
                        </Stack>
                    </Stack>
                </DialogContent>
            </Dialog>
        </>
    );
}